// extracted by mini-css-extract-plugin
module.exports = {"header":"filter_header__2ZmKx","categories":"filter_categories__2Zj_E","catTitles":"filter_catTitles__34IH4","checkbox":"filter_checkbox__3Q2Sa"};